import { render, staticRenderFns } from "./P44.vue?vue&type=template&id=51d815ea&scoped=true"
import script from "./P44.ts?vue&type=script&lang=ts&external"
export * from "./P44.ts?vue&type=script&lang=ts&external"
import style0 from "./P44.vue?vue&type=style&index=0&id=51d815ea&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d815ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51d815ea')) {
      api.createRecord('51d815ea', component.options)
    } else {
      api.reload('51d815ea', component.options)
    }
    module.hot.accept("./P44.vue?vue&type=template&id=51d815ea&scoped=true", function () {
      api.rerender('51d815ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/ProcessesForms/pages/P44/P44.vue"
export default component.exports